import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import ErrorBoundary from '@sbt-web/error-boundary';
import { getCookie } from '@sbt-web/utils';
import { FavoriteCounterHeart } from './Heart';

/**
 * when user save or unsave favorites ewe stored the value on a cookie for 5minutes.
 * In this way we workaround the page cache.
 * The cookie will not be longer necessary when the page will have, for example, the "max-age" set to zero
 */
const COOKIE_FAVORITE_COUNTER_CACHE = 'COOKIE_FAVORITE_COUNTER_CACHE';
const EXPIRE_DATE = 300;
export const getPathName = function () {
  return window.location.pathname;
};
export const updateCookie = function (value: number): string {
  const cookieValue = `${COOKIE_FAVORITE_COUNTER_CACHE}=${value};path=${getPathName()};max-age=${EXPIRE_DATE}`;
  document.cookie = cookieValue;
  return cookieValue;
};
interface Props {
  value?: number;
}
export function useFavoriteCounter(initFavoriteCounter) {
  const $ = _c(10);
  const [usersFollowAd, setUsersFollowAd] = useState(initFavoriteCounter);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const value = getCookie(COOKIE_FAVORITE_COUNTER_CACHE);
      if (value) {
        const castedValue = Number(value);
        if (!isNaN(castedValue)) {
          setUsersFollowAd(castedValue);
        }
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== usersFollowAd) {
    t2 = () => {
      if (usersFollowAd !== undefined) {
        const newValue = usersFollowAd + 1;
        setUsersFollowAd(newValue);
        updateCookie(newValue);
      }
    };
    $[2] = usersFollowAd;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onSaveFavorite = t2;
  let t3;
  if ($[4] !== usersFollowAd) {
    t3 = () => {
      if (usersFollowAd && usersFollowAd > 0) {
        const newValue_0 = usersFollowAd - 1;
        setUsersFollowAd(newValue_0);
        updateCookie(newValue_0);
      }
    };
    $[4] = usersFollowAd;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onUnsaveFavorite = t3;
  let t4;
  if ($[6] !== onSaveFavorite || $[7] !== onUnsaveFavorite || $[8] !== usersFollowAd) {
    t4 = [usersFollowAd, onSaveFavorite, onUnsaveFavorite];
    $[6] = onSaveFavorite;
    $[7] = onUnsaveFavorite;
    $[8] = usersFollowAd;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}

/**
 * FavoriteCounter component is the domain of "User Lister" tribe,
 * thus we encapsulated it into the ErrorBoundary component, to avoid problem to the
 * rest of the page
 */
export const FavoriteCounterWrapper = t0 => {
  const $ = _c(2);
  const {
    value
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = value !== undefined ? <ErrorBoundary><FavoriteCounterHeart value={value} /></ErrorBoundary> : null;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
FavoriteCounterWrapper.displayName = 'FavoriteCounter';